import { stationsReducer,stationIdReducer,stationIndexReducer } from "./stations/reducer";
import { pageNameReducer, anaChartReducer } from "./globalData/reducer";
import storageSession from "redux-persist/lib/storage/session";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import { authenticationReducer } from "./authentication/reducer";
import { profileApi } from "services/profileService";
import { dashboardApi } from "services/dashboardService";
import { stationsApi } from "../services/stationsService";
import { chargersApi } from "../services/chargersService";
import { supportApi } from "../services/supportService";
import { exportApi } from "services/exportService";
import { transactionsApi } from "services/transactionsService";
import { userApi } from "services/userService"
import { pricingApi } from "services/pricingService";
import { fleetApi } from "services/fleetService";
import { analysisApi } from "services/analysisService";
import { teamApi } from "services/teamService";
import { stationAPI } from "services/stationService";

const persistConfig = {
	key: "root",
	storage: storageSession,
	whitelist: [
		"authenticationReducer",
		"stationsReducer",
		"pageNameReducer",
		"anaChartReducer",
		profileApi.reducerPath,
		dashboardApi.reducerPath,
		stationsApi.reducerPath,
		supportApi.reducerPath,
		chargersApi.reducerPath,
		exportApi.reducerPath,
		transactionsApi.reducerPath,
		userApi.reducerPath,
		pricingApi.reducerPath,
		fleetApi.reducerPath,
		analysisApi.reducerPath,
		teamApi.reducerPath,
		stationAPI.reducerPath,
	],
};

const rootReducer = combineReducers({
	authenticationReducer,
	stationsReducer,
	stationIdReducer,
	stationIndexReducer,
	pageNameReducer,
	anaChartReducer,
	[profileApi.reducerPath]: profileApi.reducer,
	[dashboardApi.reducerPath]: dashboardApi.reducer,
	[stationsApi.reducerPath]: stationsApi.reducer,
	[chargersApi.reducerPath]: chargersApi.reducer,
	[supportApi.reducerPath]: supportApi.reducer,
	[exportApi.reducerPath]: exportApi.reducer,
	[transactionsApi.reducerPath]: transactionsApi.reducer,
	[userApi.reducerPath]: userApi.reducer,
	[pricingApi.reducerPath]: pricingApi.reducer,
	[fleetApi.reducerPath]: fleetApi.reducer,
	[analysisApi.reducerPath]: analysisApi.reducer,
	[teamApi.reducerPath]: teamApi.reducer,
	[stationAPI.reducerPath]: stationAPI.reducer,
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);

export type rootReducerType = ReturnType<typeof rootReducer>;
